import { CustomeDialog } from "../../../shared";
import { Box, Button, Stack, Typography } from "@mui/material";

export const PublishNotificationOrPromoALert = ({
  open,
  name,
  type = "Promo or Notification",
  status = null,
  onPublish,
  onClose,
}) => {
  return (
    <CustomeDialog
      open={open}
      PaperProps={{
        sx: {
          width: "423px",
          p: "24px",
        },
      }}
      title={`Publish ${type}?`}
      content={
        <Box>
          <Typography variant="body1" my="12px">
            Are you sure you want to publish
            <Box component="span" sx={{ fontWeight: 600 }}>
              {` "${name}"?`}
            </Box>
            {status === "draft" && "You won’t be able to edit it later"}
          </Typography>
          <Stack direction="row" gap="12px" justifyContent="flex-end">
            <Button color="info" variant="text" size="small" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" size="small" onClick={onPublish}>
              Publish
            </Button>
          </Stack>
        </Box>
      }
    />
  );
};
